module.exports = __webpack_public_path__ + "static/media/OTA2019_sea_lion-sc.5e137785.jpg";